import { useState, useEffect, useCallback } from 'react';
import { merchantApi } from '../api/config';

interface Slip2GoAccountInfo {
  provider?: 'slip2go' | 'easyslip';
  shopName: string;
  package: string;
  packageExpiredDate: string;
  tokenLimit: number | null;
  tokenRemaining: number;
  creditRemaining: number;
  autoRenewalPackage: boolean;
  checkSlipByCredit: boolean;
  quotaQrLimit: number;
  quotaQrRemaining: number;
}

export function useSlip2GoBalance(intervalMs = 30000) {
  const [info, setInfo] = useState<Slip2GoAccountInfo | null>(null);

  const loadInfo = useCallback(async () => {
    try {
      const res = await merchantApi.get('/admin/slip2go-account');
      if (res.data?.data) setInfo(res.data.data);
    } catch {
      // silent fail — not critical
    }
  }, []);

  useEffect(() => {
    loadInfo();
    const id = setInterval(loadInfo, intervalMs);
    return () => clearInterval(id);
  }, [loadInfo, intervalMs]);

  return info;
}
